export default class Marquee {
    constructor(element) {
        this.element = element;
        this.track = this.element.querySelector('.marquee-track, .marquee-content');
        this.speed = parseInt(this.element.dataset.speed, 10) || 50;
        this.direction = this.element.dataset.direction === 'reverse' ? -1 : 1;
        this.spacing = parseInt(this.element.dataset.spacing, 10) || 0;

        this.cloneContent();
        this.setGalleryHeight();
        this.position = 0;
        this.lastTime = null;

        this.init();
    }

    cloneContent() {
        const clone = this.track.cloneNode(true);
        this.element.appendChild(clone);
        this.clone = clone;
    }

    setGalleryHeight() {
        const children = this.track.children;
        let maxHeight = 0;
        for (let child of children) {
            const h = child.offsetHeight;
            if (h > maxHeight) maxHeight = h;
        }
        this.element.style.height = `${maxHeight}px`;
    }

    init() {
        requestAnimationFrame(this.animate.bind(this));
    }

    animate(timestamp) {
        if (!this.lastTime) this.lastTime = timestamp;
        const delta = timestamp - this.lastTime;
        this.lastTime = timestamp;

        this.position += (this.speed / 1000) * delta * this.direction;

        const trackWidth = this.track.scrollWidth;

        if (this.direction === 1 && this.position >= trackWidth + this.spacing) {
            this.position = 0;
        } else if (this.direction === -1 && this.position <= -(trackWidth + this.spacing)) {
            this.position = 0;
        }

        this.track.style.transform = `translateX(${-this.position}px)`;
        this.clone.style.transform = `translateX(${-this.position + (trackWidth + this.spacing) * this.direction}px)`;

        requestAnimationFrame(this.animate.bind(this));
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-component="Marquee"]').forEach(el => {
        new Marquee(el);
    });
});
